import axios from "axios";
import Globais, { validateToken } from "../../../components/Globais";
import { Reserva } from "../interfaces/Reserva";
import { formatDate } from "../../../uteis/dateUtils";

// Função para buscar as reservas

export const reservaSemPeriodoService = async () => {
  const Token = validateToken();
  if (Token) {
    const URL = `${Globais.DOMINIOBACK}/reserva`;

    try {
      const response = await axios.get(URL, {
        headers: { Authorization: Token.AuthStr },
      });

      if (Object.keys(response.data).length > 0) {
        const data = response.data;

        // Verifica se é um objeto e transforma em array
        const reservasArray = Array.isArray(data) ? data : [data];

        const reservasProcessadas = reservasArray
          .filter((p: Reserva) => p.periodoUsuarioId == null) // Filtra apenas os itens onde periodoUsuarioId está vazio
          .map((p: Reserva) => {
            const formattedDate = formatDate(p.dataReserva);

            return {
              ...p,
              key: p.id,
              dataReserva: formattedDate, // Passa o valor como Date
              idReservaOta: p.idReservaOta,
              periodoUsuario: p.periodoUsuarioId,
            };
          });

        return reservasProcessadas; // Agora retorna o array processado
      } else {
        return [];
      }
    } catch (error) {
      console.log(error);
    }
  }
  return []; // Retorna um array vazio se o Token não for válido
};

export {};
